module.exports = __webpack_public_path__ + "img/648eadf986b6dfbc0f3dcd148e12be62.png";